import { initReCaptcha } from './recaptcha';

initReCaptcha();
